import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import { FieldGroup, FormBlock } from '@/ui'
import { PageRead, Website } from '@/api/dashboard'
import {
  HubSettingsPageSeoField,
  HubSettingsPageSeoFieldSkeleton,
} from '@/layouts/hub-settings/widgets/HubSettingsPageSeoField'
import { PageSocialPreview } from '@/layouts/hub-settings/components'

type FormInput = Pick<PageRead, 'seo'>

interface HubSettingsPageFormProps {
  website: Website
  page: PageRead
}

export const HubSettingsPageFields = ({ website, page }: HubSettingsPageFormProps) => {
  const { t } = useTranslation('', { keyPrefix: 'hub-settings.page-settings.seo' })
  const methods = useFormContext<FormInput>()
  const { register, control, watch } = methods
  const [title, desc, imageUrl] = watch(['seo.title', 'seo.description', 'seo.image_url'])

  const initial = {
    title: page.title,
    desc: page.description || website.description,
    imageUrl: page.image_url || website.image_url,
  }

  return (
    <FormBlock title={t('title', { name: page.title })} description={t('caption', { name: page.title })}>
      <div className="flex flex-col gap-3">
        <HubSettingsPageSeoField
          name="seo"
          control={control}
          register={register}
          defaults={{
            title: initial.title,
            description: initial.desc,
          }}
        />

        <FieldGroup label={t('social.preview.label')}>
          <PageSocialPreview
            title={title || initial.title}
            desc={desc || initial.desc}
            imageUrl={imageUrl || initial.imageUrl}
          />
        </FieldGroup>
      </div>
    </FormBlock>
  )
}

export const HubSettingsPageFieldsSkeleton = () => (
  <FormBlock title="">
    <HubSettingsPageSeoFieldSkeleton />
  </FormBlock>
)
